export const isDeferredOverride = ({ mode }) => mode && ['store-associate'].includes(mode);
